import { MODULE_LAYOUT_LABELS } from "entities/modules/constants";
import { GamesModuleLayout, StudiosModuleLayout } from "entities/modules/types";
import { SelectOption } from "shared/components/Form/Select";

export const MODULE_THREE_CARDS_BLOCKS = "moduleTemplates-three-card";
export const MODULE_ONE_CARD_BLOCKS = "moduleTemplates-one-card";
export const MODULE_TOP_PRIVACY_TIPS_BLOCK =
  "moduleTemplates-top-privacy-tips-block";

export const gamesLayoutOptionsWithStudioFilter: SelectOption[] = [
  {
    value: GamesModuleLayout.VerticalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTiles],
  },
  {
    value: GamesModuleLayout.HorizontalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTiles],
  },
];

export const studiosLayoutOptions: SelectOption[] = [
  {
    value: StudiosModuleLayout.HorizontalLogos,
    label: MODULE_LAYOUT_LABELS[StudiosModuleLayout.HorizontalLogos],
  },
];

export const gamesLayoutOptions: SelectOption[] = [
  {
    value: GamesModuleLayout.VerticalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTiles],
  },
  {
    value: GamesModuleLayout.VerticalTilesStacked,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.VerticalTilesStacked],
  },
  {
    value: GamesModuleLayout.HorizontalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTiles],
  },
  {
    value: GamesModuleLayout.HorizontalTilesStacked,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.HorizontalTilesStacked],
  },
  {
    value: GamesModuleLayout.BigHorizontalTiles,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.BigHorizontalTiles],
  },
  {
    value: GamesModuleLayout.Top10Games,
    label: MODULE_LAYOUT_LABELS[GamesModuleLayout.Top10Games],
  },
];
